module.exports = __webpack_public_path__ + "img/add-photo-third-icon-male.0dfaf4df.svg";